import PropTypes from 'prop-types';
import React from 'react';
import SecondaryNav from '../../Common/containers/SecondaryNav';

function CricketNav({open, opener}) {
  const props = {
    open,
    opener,
    title: "Cricket",
    links: [
      {href: "/cricket", text: "News", isIndex: true}
    ]
  };

  return (
    <SecondaryNav {...props}/>
  );
}

CricketNav.propTypes = {
  open: PropTypes.bool.isRequired,
  opener: PropTypes.func.isRequired
}

export default CricketNav



// WEBPACK FOOTER //
// ./modules/Cricket/nav/CricketNav.js